var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"j-start align-center"},[_c('from-until-dates',{attrs:{"from_date":_vm.from_date,"until_date":_vm.until_date},on:{"setFrom":_vm.setFrom,"setUntil":_vm.setUntil}}),_c('b-button',{staticClass:"m-l-15",attrs:{"variant":"primary"},on:{"click":_vm.getSales}},[_vm._v(" Buscar ")]),_c('hr')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }